<template>
  <ValidationObserver @submit="submitForm">
    <UiModalContainer
      footer-classes="flex gap-3"
      :disable-position-center="true"
      :modal-show="showModal"
      @handleClick="handleClick"
    >
      <template v-slot:header>
        <span>{{ userData.heading }}</span>
      </template>
      <UserDetailedView :user="userCandidate" @filter="getUserInfo" />
      <Divider />
      <InputFieldWrapper>
        <UiInput
          v-model.trim="userPassword"
          type="password"
          name="Password"
          title="ENTER_PASSWORD"
          label="Password"
          placeholder="Password"
          rules="min:8|required"
          autocomplete="new-password"
        />
      </InputFieldWrapper>
      <template v-slot:footer>
        <div class="flex gap-3 md:flex-row w-full flex-col">
          <div
            class="flex flex-1 px-1 text-xs items-center md:text-base font-bold text-primary-green"
          >
            <span class="text-label-text">{{ userData.message }}</span>
          </div>
          <div class="flex gap-3 justify-end rtl:gap-x-4">
            <UIButton :disabled="isLoading" @click="handleClick('close')">Cancel</UIButton>
            <UIButton button="primary">
              <template v-if="isLoading">
                <Loader></Loader>
              </template>
              <template v-else>
                <span>{{ userData.buttonText }}</span>
              </template>
            </UIButton>
          </div>
        </div>
      </template>
    </UiModalContainer>
  </ValidationObserver>
</template>

<script>
/* Components */
import UiModalContainer from '@components/UiElements/UiModalContainer.vue'
import Loader from '@components/BaseComponent/Loader.vue'

/* 3rd party compononent */
import UserDetailedView from '@src/components/userDetailedView.vue'
import { Form as ValidationObserver } from 'vee-validate'
import UiSingleSelect from '@/src/components/UiElements/UiSingleSelect.vue'
import { transformGuardianData } from '@src/utils/settings/tenant-user.util.js'
import UiInput from '@components/UiElements/UiInputBox.vue'
import { currentUTCDateTimeWithZone } from '@src/utils/moment.util.js'
import UIButton from '@src/components/UiElements/UIButton.vue'
import Divider from '@src/components/Divider.vue'

/* VUEX */
import { mapActions, mapState } from 'vuex'
import InputFieldWrapper from '@src/components/UiElements/InputFieldWrapper.vue'
export default {
  components: {
    UiModalContainer,
    ValidationObserver,
    Loader,
    UserDetailedView,
    UiInput,
    UIButton,
    Divider,
    InputFieldWrapper,
  },
  emits: ['success'],
  data() {
    return {
      title: 'title',
      userCandidate: null,
      dashboard: 'dashboard',
      isLoading: false,
      showModal: false,
      userPassword: '',
      userData: {
        buttonText: 'Deactivate',
        message: 'Are you sure you want to deactivate this user ? ',
        heading: 'Deactivate Modal',
      },
    }
  },
  computed: {
    ...mapState({
      showDeactivateModal: (state) => state?.layout?.showDeactivateModal,
      currentSelectedUser: (state) => state.layout.currentSelectedUser,
    }),
  },
  watch: {
    showDeactivateModal: {
      handler(value) {
        if (value) {
          this.userPassword = null
          this.getUserInfo(this.currentSelectedUser)
        } else this.showModal = false
      },
    },
  },

  methods: {
    async getUserInfo(data) {
      let queryParam = {
        skip: data?.range?.skip || 0,
        limit: data?.range?.limit || 5,
      }
      let query = {
        id: data?.id,
        payload: queryParam,
      }
      this.isLoading = true
      await this.getUserDetails(query)
        .then((res) => {
          this.userCandidate = res.data
          this.showModal = this.showDeactivateModal
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    handleClick(eventName) {
      switch (eventName) {
        case 'close':
          this.$store.commit('layout/SET_SHOW_DEACTIVATE_MODAL', false)
          break
      }
    },
    submitForm() {
      let data = {
        id: this.currentSelectedUser?.id,
        password: this.userPassword,
      }
      this.isLoading = true
      this.deactivateInstituteUser(data)
        .then(() => {
          this.handleClick('close')
          this.$emit('success')
        })
        .finally(() => {
          this.isLoading = false
        })
    },

    ...mapActions('users', ['getUserDetails']),
    ...mapActions('institute', ['deactivateInstituteUser']),
  },
}
</script>

<style lang="scss" scoped>
@media (max-width: 600px) {
  .primary-button {
    min-width: 83px;
  }
  .primary-button-outline {
    min-width: 83px;
  }
}
</style>
